// List of Moengage events.
const User_Login = "User Login";
const Profile_Update = "Profile Update";
const Subscription_Purchased = "Subscription Purchased";
const Content_Played = "Content Played";
const Content_Paused = "Content Paused";
const Content_Completed = "Content Completed";
const Content_Liked = "Content Liked";
const Content_Shared = "Content Shared";
const Replay = "Replay";
const Thumbnail_Displayed = "Thumbnail Displayed"; // Need Clarity
const Thumbnail_Clicked = "Thumbnail Clicked"; // Need Clarity
const Program_Watched = "Program Watched";
const Movie_Watched = "Movie Watched";
const News_Video_Played = "News Video Played";
const Track_Played = "Track Played"; // Need Clarity
const Short_Video_Viewed = "Short Video Viewed";
const Continue_Watching_Engagement = "Continue Watching Engagement";
const Search_Performed = "Search Performed";
const Search_Result_Clicked = "Search Result Clicked";
const Watchlist_Added = "Watchlist Added";
const Watchlist_Removed = "Watchlist Removed";
const Session_Ended = "Session Ended"; // Need Clarity
const Drop_off_During_Browsing = "Drop-off During Browsing"; // Need Clarity
const Daily_Watch_Streak = "Daily Watch Streak"; // Need Clarity
const Recommendations_Clicked = "Recommendations Clicked"; // Need Clarity
const Page_Load = "Page Load"; // Need Clarity
const Error_Occurred = "Error Occurred";

const dispatchMoEngageEvent = (EventType, data) => {
  console.log("data",data)
  if (typeof window !== "undefined") {
    if (typeof window?.Moengage !== "undefined") {
      window?.Moengage?.track_event(EventType, data);
    }
  }
};

const MoEngageEvents = {
  LoginEvent: (data) => dispatchMoEngageEvent(User_Login, data),
  ProfileUpdate: (data) => dispatchMoEngageEvent(Profile_Update, data),
  SubscriptionPurchased: (data) =>
    dispatchMoEngageEvent(Subscription_Purchased, data),
  ContentPlayed: (data) => dispatchMoEngageEvent(Content_Played,data),
  ContentPaused: (data) => dispatchMoEngageEvent(Content_Paused, data),
  ContentCompleted: (data) => dispatchMoEngageEvent(Content_Completed, data),
  ContentLiked: (data) => dispatchMoEngageEvent(Content_Liked, data),
  ContentShared: (data) => dispatchMoEngageEvent(Content_Shared, data),
  Replay: (data) => dispatchMoEngageEvent(Replay, data),
  ThumbnailDisplayed: (data) =>
    dispatchMoEngageEvent(Thumbnail_Displayed, data),
  ThumbnailClicked: (data) => dispatchMoEngageEvent(Thumbnail_Clicked, data),
  ProgramWatched: (data) => dispatchMoEngageEvent(Program_Watched, data),
  MovieWatched: (data) => dispatchMoEngageEvent(Movie_Watched, data),
  NewsVideoPlayed: (data) => dispatchMoEngageEvent(News_Video_Played, data),
  TrackPlayed: (data) => dispatchMoEngageEvent(Track_Played, data),
  ShortVideoViewed: (data) => dispatchMoEngageEvent(Short_Video_Viewed, data),
  ContinueWatchingEngagement: (data) =>
    dispatchMoEngageEvent(Continue_Watching_Engagement, data),
  SearchPerformed: (data) => dispatchMoEngageEvent(Search_Performed, data),
  SearchResultClicked: (data) =>
    dispatchMoEngageEvent(Search_Result_Clicked, data),
  WatchlistAdded: (data) => dispatchMoEngageEvent(Watchlist_Added, data),
  WatchlistRemoved: (data) => dispatchMoEngageEvent(Watchlist_Removed, data),
  SessionEnded: (data) => dispatchMoEngageEvent(Session_Ended, data),
  DropoffDuringBrowsing: (data) =>
    dispatchMoEngageEvent(Drop_off_During_Browsing, data),
  DailyWatchStreak: (data) => dispatchMoEngageEvent(Daily_Watch_Streak, data),
  RecommendationsClicked: (data) =>
    dispatchMoEngageEvent(Recommendations_Clicked, data),
  PageLoad: (data) => dispatchMoEngageEvent(Page_Load, data),
  ErrorOccurred: (data) => dispatchMoEngageEvent(Error_Occurred, data),
};

export default MoEngageEvents;
